import React from "react";
import styled from "styled-components";

const TotalsContainer = styled.div`
  display: inline-flex;
  font-weight: 100;
}
`;

const Total = styled.div`
  font-family: "AllianceNo2-SemiBold" !important;
  margin-right: 10px;
`;

export const MemorySummary = ({ bqnId, System, Mpool, Dpdk }) => {
  return (
    System !== null &&
    Object.keys(System)
      .filter((bqn) => bqnId === "all" || bqn.toString() === bqnId.toString())
      .filter((bqn) => System[bqn] && Mpool[bqn] && Dpdk[bqn])
      .map((bqn) => (
        <React.Fragment key={"summary-" + bqn}>
          <TotalsContainer>
            <Total>System Total: {(System[bqn] / 1024).toFixed(2)} GB</Total>
            <Total>MPool Total: {(Mpool[bqn] / 1024).toFixed(2)} GB</Total>
            {Dpdk &&
              Dpdk[bqn].map((mem, index) => {
                return (
                  <Total key={`dpdk-${bqn}-${index}`}>
                    Dpdk{index} Total: {(mem / 1024).toFixed(2)} GB
                  </Total>
                );
              })}
          </TotalsContainer>
        </React.Fragment>
      ))
  );
};
